import React from 'react';
export function SiteFooter() {
  return <footer className="bg-cream-deep py-8 sm:py-10" data-id="element-136" data-mp="1dr1f9lwgpvek">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-137" data-mp="3r7pvfrtcs52e">
        <p className="font-display text-base text-ink sm:text-lg" data-id="element-138" data-mp="3ralsldxdmpps">
          Método Nail-Elite · Business-Art System
        </p>
        <p className="mt-3 text-[11px] leading-relaxed text-ink/55 sm:mt-4 sm:text-xs" data-id="element-139" data-mp="3hizm1uvzhetd">
          Los resultados mencionados son ejemplos reales pero no típicos. Los resultados individuales
          dependen del esfuerzo, la dedicación y las condiciones del mercado local de cada alumna.
        </p>
      </div>
    </footer>;
}